import { Box, Button, Flex, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';

const SignUpInSwitch = ({ activeTab, setActiveTab, onSwitch }) => {
  const { t } = useTranslation();
  const trackBg = useColorModeValue('gray.100', 'whiteAlpha.200');
  const indicatorBg = useColorModeValue('white', 'navy.700');
  const inactiveColor = useColorModeValue('gray.600', 'whiteAlpha.700');
  const activeColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('blackAlpha.100', 'whiteAlpha.200');

  return (
    <Flex
      p="4px"
      gap={1}
      position="relative"
      w="100%"
      borderRadius="16px"
      bg={trackBg}
      border="1px solid"
      borderColor={borderColor}
      role="tablist"
      aria-label={t('auth.authentication_mode_switch')}
    >
      <Box
        bg={indicatorBg}
        width="calc(50% - 4px)"
        borderRadius="12px"
        height="calc(100% - 8px)"
        position="absolute"
        top="4px"
        left={activeTab === 'signin' ? '4px' : '50%'}
        transition="left 0.25s ease"
        boxShadow="sm"
        pointerEvents="none"
      />

      <Button
        type="button"
        fontSize={{ base: 'sm', md: 'md' }}
        fontWeight="600"
        w="50%"
        h={{ base: '46px', md: '50px' }}
        borderRadius="12px"
        variant="ghost"
        color={activeTab === 'signin' ? activeColor : inactiveColor}
        onClick={() => {
          setActiveTab('signin');
          onSwitch?.('signin');
        }}
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        role="tab"
        aria-selected={activeTab === 'signin'}
        aria-controls="auth-form-panel"
      >
        {t('auth.sign_in')}
      </Button>

      <Button
        type="button"
        fontSize={{ base: 'sm', md: 'md' }}
        fontWeight="600"
        w="50%"
        h={{ base: '46px', md: '50px' }}
        borderRadius="12px"
        variant="ghost"
        color={activeTab === 'signup' ? activeColor : inactiveColor}
        onClick={() => {
          setActiveTab('signup');
          onSwitch?.('signup');
        }}
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        role="tab"
        aria-selected={activeTab === 'signup'}
        aria-controls="auth-form-panel"
      >
        {t('auth.sign_up')}
      </Button>
    </Flex>
  );
};

export default SignUpInSwitch;
